// @ts-nocheck
import { navigate } from '../../lib/routerAdapter';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import notification from 'antd/lib/notification';
import dayjs, { toUtcISOString } from '../../lib/date/dayjs';
import React, { Component } from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../components/ant/DayjsDatePicker';
import CancelButton from '../../components/CancelButton';
import { Form, Selects } from './../../components';
import { Panel, Section } from './../../components/layout';
import Breadcrumbs, { Crumb } from './../../components/layout/Breadcrumbs';
import Grid, { GridItem } from './../../components/layout/Grid';
import Header from './../../components/layout/Header';
import { notificationLoading } from './../../components/Notifications';
import { businessDayApi } from './../../lib/api';
import { businessDayTypeEnum } from './../../lib/enum';
const Content = styled.div.withConfig({
  displayName: "BusinessDayForm__Content",
  componentId: "sc-i1llq8-0"
})(["padding:16px;"]);
const {
  TextArea
} = Input;
const {
  BusinessDayTypeSelect
} = Selects;
const Footer = styled(Section).withConfig({
  displayName: "BusinessDayForm__Footer",
  componentId: "sc-i1llq8-1"
})(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);
const StyledPanel = styled(Panel).withConfig({
  displayName: "BusinessDayForm__StyledPanel",
  componentId: "sc-i1llq8-2"
})(["padding-top:0;"]);
class BusinessDayForm extends Component {
  state = {
    businessDay: {
      dayType: businessDayTypeEnum.dayOff
    }
  };
  async componentDidMount() {
    const dayId = parseInt(this.props.dayId);
    if (dayId > 0) {
      const businessDay = await businessDayApi.fetchBusinessDay(dayId);
      this.setState({
        businessDay
      });
    }
  }
  goBack = () => navigate('/admin/business-calendar');
  onSubmit = async businessDay => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      const dayId = parseInt(this.props.dayId);
      if (dayId > 0) {
        await businessDayApi.updateBusinessDay(businessDay);
        notification.success({
          message: 'Успешное обновление',
          description: 'Данные были успешно обновлены'
        });
      } else {
        await businessDayApi.addBusinessDay(businessDay);
        notification.success({
          message: 'Успешное добавлено'
        });
      }
      this.goBack();
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };
  render() {
    const {
      businessDay
    } = this.state;
    return <>
        <Header left={<Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/business-calendar">
                Производственный календарь
              </Crumb>
              {businessDay ? <Crumb>Редактирование дня</Crumb> : <Crumb>Новый день</Crumb>}
            </Breadcrumbs>} />
        <StyledPanel>
          <h1>{businessDay ? `Редактирование дня` : 'Новый день'}</h1>
        </StyledPanel>
        <InnerForm businessDay={businessDay} onSubmit={this.onSubmit} onCancel={this.goBack} />
      </>;
  }
}
const InnerForm = ({
  onSubmit,
  onCancel,
  businessDay
}) => <Form initialValues={businessDay} onSubmit={onSubmit}>
    {(FormField, formikProps) => {
    const {
      handleSubmit,
      handleBlur,
      setFieldValue,
      dirty,
      isSubmitting
    } = formikProps;
    return <form onSubmit={handleSubmit}>
          <Section>
            <Content>
              <Grid gutter="16px">
                <GridItem>
                  <FormField label="Дата" required name="date" fast>
                    {({
                  value,
                  name
                }) => <DatePicker format="DD.MM.YYYY" value={value ? dayjs.utc(value) : value} onChange={(value, dateString) => {
                  setFieldValue(name, toUtcISOString(dateString, 'DD.MM.YYYY'));
                }} />}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Тип дня" required name="dayType" fast>
                    {({
                  name,
                  value
                }) => <BusinessDayTypeSelect name={name} value={value} onBlur={() => handleBlur({
                  target: {
                    name
                  }
                })} onChange={value => setFieldValue(name, value)} />}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField name="description" label="Описание" fast>
                    {field => <TextArea {...field} />}
                  </FormField>
                </GridItem>
              </Grid>
            </Content>
          </Section>
          <Footer>
            <Button disabled={isSubmitting} loading={isSubmitting} type="primary" htmlType="submit" data-cy="save">
              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>;
  }}
  </Form>;
export default BusinessDayForm;
